import React, {Component} from 'react';
//import flag from '../img/a.png';
class Links extends Component {
    
    
    render() {
       
            return (

<section className="pb-6">
    <div className="container">
        <div className="row">
            <div className="col-md-8 mx-auto">
                <h2 className="text-center text-md-left">useful links</h2>
                <p className="lead text-muted">Read this article to get the access token</p>
                   <h2 className="light"> <a href="https://mohammedraji.github.io/posts/get-instagram-graph-API/">How to get Instagram Graph API access token</a>
</h2>
                
            </div>
        </div>
    </div>
</section>

                

            );

        }

    }


export default Links;
